import React, { Component } from 'react'
import 'worldwindjs'
import axios from 'axios';
import { osintRequestAddress } from '../config'

/* global WorldWind */
export default class EventsLayer extends Component{
    state = {
        isEventListGot: false
    }
    // 飞机图标配置
    static eventIcons = [
        "./event.png",
        "https://files.worldwind.arc.nasa.gov/artifactory/web/0.9.0/images/pushpins/castshadow-red.png",
    ];

    componentDidMount(){
        if (this.state.isEventListGot){
            return
        }  
        // Create a placemark using the selected marker image
        let attributes = new WorldWind.PlacemarkAttributes(null);
        attributes.imageScale = 0.8;
        attributes.imageOffset = new WorldWind.Offset(
            WorldWind.OFFSET_FRACTION, 0.5,
            WorldWind.OFFSET_FRACTION, 0.5);
        attributes.imageColor = WorldWind.Color.WHITE;
        attributes.labelAttributes.offset = new WorldWind.Offset(
            WorldWind.OFFSET_FRACTION, 0.5,
            WorldWind.OFFSET_FRACTION, 1.8);
        attributes.labelAttributes.color = WorldWind.Color.YELLOW;
        attributes.labelAttributes.scale = 2.5;
        attributes.drawLeaderLine = true;
        attributes.leaderLineAttributes.outlineColor = WorldWind.Color.RED;
        attributes.imageSource = EventsLayer.eventIcons[0];

        let lineAttributes = new WorldWind.ShapeAttributes();  
        lineAttributes.outlineColor = WorldWind.Color.YELLOW;
        lineAttributes.outlineWidth = 3;


        axios.get(`${osintRequestAddress}/events`).then(
            response => {
                if (response.data && response.data.length>0){
                    const globe = this.props.globe;
                    const layer = globe.getLayer(this.props.markersLayerName);
                    response.data.map(
                    // 为调试方便，仅取前5架飞机
                    // response.data.slice(0,4).map(
                        (event) => {
                            var position = {latitude:event.lat,longitude:event.lon,altitude:0} 
                            let placemark = new WorldWind.Placemark(position, /*eyeDistanceScaling*/ true, attributes)
                            placemark.type = 'event'
                            placemark.label = event.id.toString();                        
                            placemark.eyeDistanceScalingThreshold = 2500000; 
                            placemark.eyeDistanceScalingLabelThreshold = 5000;                   
                            // Add the line and marker to the layer and to the Markers component                            
                            if (layer) {                           
                                layer.addRenderable(placemark)
                                // send the events to the Markers component                            
                                this.props.addEvent(placemark, event)
                            } else {
                                console.warn("Renderable layer for lines not found: "+ this.props.markersLayerName);
                            }
                            return ""                           
                        }                        
                    )                   
                    this.setState({isEventListGot:true})
                }
            },
            error => {console.log("error",error)}
        )
    } 
    render(){
        return <div></div>
    }
}
